import { Dialog, DialogContent, DialogTitle, Select, TextField, Grid, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { ls } from "../../../../variables";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { encrypt } from "../../../../utils/cipher";
import { useStateValue } from "../../../../Hooks/stateProvider";
import { errorHandler } from "../../../../utils/errorHandling";
import { alert } from "../../../../utils/sweetAlert";
import PlusSign from "../../../../images/Group 1000001354.svg"
import { actionsOptions } from "../../../../variables";
import { getDate } from "../../../../utils/getDate";
import UploadAction from "../../../CommonLayouts/UploadAction";

const TakeActionDialogBox = ({ openModal, setOpenModal, selectedReportType, trackerPageFetch }) => {
    const [{ moduleType, pmsName, SEBITrackerPageData, SEBITrackerData, fileName, fileDetails }, dispatch] =useStateValue();

    const navigate = useNavigate();

    const [rows, setRows] = useState([]);
    // const [complianceType, setComplianceType] = useState("");
    // const [compliancePercent, setCompliancePercent] = useState("");
    const [selectedActions, setSelectedActions] = useState([]);
    const location = useLocation();
    const formData = new FormData();
    const date = new Date();

  // Get the current year
  const year = date.getFullYear();
  
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

// Get the current month index
const monthIndex = date.getMonth();

// Get the month name
const monthName = monthNames[monthIndex];
    
    const refCount = useRef(SEBITrackerPageData.instanceCount - SEBITrackerPageData.closedCount);
    const [data, setData] = useState({ count: refCount.current, sebiComments: "", actions: [] });

    const downloadReport = async (uploadS3FilePath) => {
        if (uploadS3FilePath == undefined || uploadS3FilePath == "") {
            alert("Sorry!!", "No File Found", "error");
            return;
        }
        const downloadPayload = {
            s3Location: uploadS3FilePath,
            moduleType: moduleType,
            authToken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken"),
        };
        const encryptedPayload = await encrypt(downloadPayload);
        const result = axios.post(
            "/api/pms/downloadReport",
            { payload: encryptedPayload },
            {
                withCredentials: true,
            }
        );
        result
            .then((response) => {
                if (response.data.success) {
                    window.open(response.data.data, "_self");
                }
            })
            .catch((err) => {
                errorHandler(err, navigate);
            });
    };

    const alertColumns = [
        {
            field: "date",
            headerName: "Date",
            minWidth: 80,
            flex: 1,
            headerClassName: "header-blue",
            headerAlign: "center",
            align: "center",
            sortable: false,
            cellClassName: "no-border-left",
            renderCell: (params) => {
                return <>{params.row.date}</>;
            },
        },
        {
            field: "caseIdNumber",
            headerName: "No. of Case IDs",
            minWidth: 160,
            flex: 1.5,
            align: "center",
            headerClassName: "header-blue",
            headerAlign: "center",
            sortable: false,
            renderCell: (params) => {
                return (
                    <>
                        {params.row.count}
                    </>
                );
            },
        },

        {
            field: "sebiComment",
            headerName: "SEBI Comments",
            minWidth: 300,
            flex: 0.5,
            align: "center",
            headerClassName: "header-blue",
            headerAlign: "center",
            sortable: false,
            renderCell: (params) => {
                return (
                    <div style={{
                        minHeight: "2rem",
                        maxHeight: "5rem", whiteSpace: "pre-wrap",
                        overflow: "auto",
                        height: "100%",
                        width: "100%",
                        borderRadius: "5px",
                        padding: "5px"
                    }}>{params.row?.sebiComments}</div>
                );
            },
        },
        {
            field: "closure",
            headerName: "Closure",
            minWidth: 300,
            flex: 0.5,
            align: "center",
            headerClassName: "header-blue",
            headerAlign: "center",
            sortable: false,
            renderCell: (params) => {
                return (<div style={{
                    minHeight: "2rem",
                    maxHeight: "5rem", whiteSpace: "pre-wrap",
                    overflow: "auto",
                    height: "100%",
                    width: "100%",
                    borderRadius: "5px",
                    padding: "5px"
                }}>{params.row.actions?.join(", ")}</div>)
            },
        },
    ];


    const handleActionsChange = (val, type = "selectAll") => {
        if (type == "selectAll") {
            if ((selectedActions.length === actionsOptions.length - 1) && !selectedActions.includes("Seek Explaination")) {
                setSelectedActions([]);
            }
            else {
                setSelectedActions(actionsOptions.filter(val => val.value != "Seek Explaination").map(val => val.value));
            }
        }
        else {
            const isSeekExplanationSelected = val === 'Seek Explaination';
            if (selectedActions.includes('Seek Explaination')) {
                if (isSeekExplanationSelected) {
                    setSelectedActions([])
                } else {
                    setSelectedActions([val])
                }
            } else {
                if (isSeekExplanationSelected) {
                    setSelectedActions(['Seek Explaination']);
                } else {
                    if (selectedActions.includes(val)) {
                        setSelectedActions(selectedActions.filter(selectedId => selectedId !== val));
                    } else {
                        setSelectedActions([...selectedActions, val]);
                    }
                }
            }
        }
    };

    const handleClick = () => {
        if (data.count == "" || data.count == "0") return;
        refCount.current -= data.count
        setRows([...rows, { ...data, id: rows.length + 1, date: getDate(), status: data.actions.includes('Seek Explaination') ? "open" : "closed" }]);
        setData({ count: refCount.current, sebiComments: "", actions: [] });
        setSelectedActions([])
    }

    const handleSubmit = async () => {
        const payload = {
            fy_year: SEBITrackerData.fy_year,
            quarter: SEBITrackerData.quarter,
            pmsName: ls.get("selectedfundname"),
            ticketid: SEBITrackerPageData.ticketID,
            guidancetype: SEBITrackerPageData.guidanceType,
            listofActions: rows,
            moduleType: moduleType,
            userType: "SEBI",
            month:monthName,
            year:year
        }
        const encryptedFormData = await encrypt(payload);
        const encryptedHeaders = await encrypt({
            authtoken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken")
        })
        formData.append("file", fileDetails);
        formData.append("fileName", fileName);
        formData.append("payload", encryptedFormData);

        axios
            .post("/api/pms/settlementUpload", formData, {
                withCredentials: true,
                headers: {
                    headers: encryptedHeaders
                }
            })
            .then((response) => {
                if (response.data.success) {
                    setOpenModal(false);
                    trackerPageFetch();
                }
            })
            .catch((err) => errorHandler(err, navigate))
    }

    useEffect(()=>{
        setData({...data, actions: selectedActions})
    },[selectedActions])

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                sx: {
                    height: "fit-content",
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <span>Comments</span>
                <div className="closeIcon" onClick={() => setOpenModal(false)}>
                    <CloseIcon
                        sx={{ cursor: "pointer", "&:hover": { color: "#ff0000" } }}
                    />
                </div>
            </DialogTitle>
            <DialogContent
                sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "1rem",
                    height: "100%"
                }}
            >
                <div style={{ height: "40vh", width: "100%" }}>
                    <DataGrid
                        getRowId={(row) => row.id}
                        rows={rows}
                        columns={alertColumns}
                        getRowHeight={() => "auto"}
                        sx={{
                            backgroundColor: "#EAEAEA",
                            borderColor: "#154063",
                            width: "100%",
                            "& .MuiDataGrid-columnHeaderTitleContainer": {
                                justifyContent: "center",
                                color: "black"
                            },
                            "& .MuiDataGrid-cellContent": {
                                fontSize: "0.8rem",
                            },
                            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                                display: "none",
                            },
                            "& .MuiDataGrid-columnHeaders": { width: "fit-content", borderBottom: "1px solid #154063" },
                            "& .MuiDataGrid-columnHeader": { backgroundColor: "#EAEAEA", borderRight: "1px solid #154063" },
                            // "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
                            "& .MuiDataGrid-cell": {
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                borderRight: "1px solid #154063",
                                borderBottom: "2px solid #D9D9D9"
                            },
                            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                py: "5px",
                            },
                            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                py: "8px",
                            },
                            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                py: "15px",
                            },
                        }}
                        hideFooter
                        showCellVerticalBorder
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "row", backgroundColor: "#F6F6F6", height: "50%", width: "100%", borderRadius: "6px" }}>
                    <Grid container spacing={1} style={{ width: "90%", margin: "0.5rem", overflow: "auto" }}>
                        <Grid item xs={6} sm={4} md={4} lg={2} style={{ display: "flex", flexDirection: "column" }}>
                            <span>Count</span>
                            <TextField
                                autoFocus
                                type="text"
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                inputProps={{
                                    min: 0,
                                    max: refCount.current,
                                }}
                                value={data.count}
                                onKeyDown={(event) => {
                                    event.stopPropagation();
                                }}
                                onChange={(e) => {
                                    // var value = parseInt(e.target.value, 10);
                                    var value = e.target.value;

                                    if (value > refCount.current) value = refCount.current;
                                    if (value < 0) value = 0;
                                    setData({ ...data, "count": value })
                                }}
                                sx={{ width: "100%", backgroundColor: "#EAEAEA", marginTop: 0, borderColor: "red" }}
                            />
                        </Grid>
                        <Grid item xs={10} sm={6} md={4} lg={4} style={{ display: "flex", flexDirection: "column" }}>
                            <span>Remarks</span>
                            <Select
                                value={data.actions}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            color: "#000000",
                                            "& .MuiMenuItem-root": {
                                                padding: 1,
                                            },
                                            height: "20%",
                                        },
                                    },
                                }}
                                sx={{
                                    backgroundColor: "#EAEAEA"
                                }}
                                displayEmpty
                                renderValue={(selected) => {
                                    if (selected?.length === 0) {
                                        return "Select Remarks";
                                    }
                                    return selected?.join(", ");
                                }
                                }
                                multiple
                            >
                                <MenuItem style={{ display: "flex", justifyContent: "center", alignItems: "center" }} onClick={handleActionsChange}>
                                    <Checkbox
                                        checked={data.actions.length === actionsOptions.length}
                                        indeterminate={data.actions.length > 0 && data.actions.length < actionsOptions.length}
                                    />
                                    <ListItemText primary="Any action taken" />
                                </MenuItem>
                                {actionsOptions.map((name) => (
                                    <MenuItem key={name.label} value={name.value} onClick={() => handleActionsChange(name.label, "select")}>
                                        <Checkbox
                                            checked={selectedActions.includes(name.value)}
                                        />
                                        <ListItemText primary={name.label} />
                                    </MenuItem>
                                ))}
                                <MenuItem key={'Seek Explaination'} value={'Seek Explaination'} onClick={() => handleActionsChange('Seek Explaination', "select")}>
                                        <Checkbox
                                            checked={selectedActions.includes('Seek Explaination')}
                                        />
                                        <ListItemText primary={'Seek Explaination'} />
                                    </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={10} sm={10} md={10} lg={6}>
                            <span>SEBI Comments</span>
                            <TextField
                                autoFocus
                                type="text"
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                maxRows={3}
                                multiline
                                placeholder="Enter Comments"
                                onChange={(e) => {
                                    setData({ ...data, "sebiComments": e.target.value })
                                }}
                                onKeyDown={(event) => {
                                    event.stopPropagation();
                                }}
                                value={data.sebiComments}
                                sx={{ width: "100%", backgroundColor: "#EAEAEA", marginTop: 0, overflow: "auto" }}
                            />
                        </Grid>
                    </Grid>
                    <div style={{ width: "10%", display: "flex", justifyContent: "center", alignItems: "center" }}>

                        <div style={{ cursor: "pointer" }} onClick={handleClick}><img src={PlusSign} /></div>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "1rem" }}>
                    <UploadAction />
                    <button style={{
                        fontSize: "0.8rem !important",
                        backgroundColor: refCount.current ? "#808080" : "#154063",
                        cursor: refCount.current ? "initial" : "pointer",
                        border: refCount.current ? "0.125rem solid #808080" : "0.125rem solid #154063",
                        borderRadius: "0.125rem",
                        width: "8.125rem",
                        height: "1.875rem",
                        color: "#fff"
                    }}
                        onClick={handleSubmit}
                        disabled={refCount.current}>
                        SUBMIT
                    </button>
                </div>
            </DialogContent>
        </Dialog >
    );
};

export default TakeActionDialogBox;
